<div class="livekit-room contents">
    <video
        #localVideo
        class="size-full object-cover"
        autoplay
        playsinline
        muted
    ></video>
    <video
        #remoteVideo
        class="hidden"
        autoplay
        playsinline
    ></video>
</div>
